import { useState, useEffect } from "react";
import { Navigation } from "@mui/icons-material";
import { useIdleTimer } from "react-idle-timer";
import { useSelector } from "react-redux";

const SessionTimeOut = () => {
  const timeout = 60000;

  //const [remaining, setRemaining] = useState(timeout)
  const [isIdle, setIsIdle] = useState(false);
  const globalSettings = useSelector(
    (state: any) => state.sitesetting.settings
  );
  const [idleTime, setIdleTime] = useState(timeout as number);

  useEffect(() => {
    if (globalSettings !== undefined && globalSettings !== null) {
      globalSettings.forEach((item: any) => {
        if (item["config_name"] === "site") {
          let configvalue = JSON.parse(item["config_value"]);
          if (configvalue.site_session_timeout) {
            let time = configvalue.site_session_timeout as unknown as number;
            setIdleTime(time * 60000);
          }
          return;
        }
      });
    }
  }, [globalSettings]);

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => {
    localStorage.clear();
    setIsIdle(false);
    window.location.href = "/login";
  };

  useIdleTimer({
    timeout: idleTime,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });

  /*   useEffect(() => {
        setRemaining(getRemainingTime())
        
        setInterval(() => {
          setRemaining(getRemainingTime())
        }, 1000)
        
      }, []) */

  const _itelTimer = <div></div>;

  return <>{isIdle ? <Navigation to="/login" /> : _itelTimer}</>;
};
export default SessionTimeOut;
